import makeStyles from '@mui/styles/makeStyles';

const fullWidth = 200;
const offset = 70;

export default makeStyles({
  '@keyframes slideClosed': {
    '0%': {
      width: fullWidth - offset,
    },
    '100%': {
      width: '0px',
    },
  },
  '@keyframes slideOpen': {
    '0%': {
      width: offset,
    },
    '100%': {
      width: fullWidth,
    },
  },
  containerBox: {
    cursor: 'pointer',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  hidden: {
    display: 'none',
  },
  icon: {
    marginRight: 10,
    display: 'inline-block',
  },
  searchOpen: {
    animation: '$slideOpen 300ms',
    width: 200,
  },
  searchClosed: {
    animation: '$slideClosed 300ms',
    width: 0,
  },
  searchLoad: {
    width: 0,
  },
});
